export enum SuppliesTrackableProductType {
  LabelPaper = "label_paper",
  ParcelPackaging = "parcel_packaging",
}
